<template>
  <div>
    <div style="margin-bottom: 10px" class="df both-side">
      <div></div>
      <a-button @click="handleUpdateProject(null)">新增</a-button>
    </div>
    <a-table
      :data-source="table.data"
      bordered
      :pagination="false"
      :columns="columns"
      rowKey="id"
    >
      <template #action="{ record }">
        <a-space>
          <a-button
            type="primary"
            @click="handleUpdateProject(record)"
            size="small"
            >修改</a-button
          >
          <a-button @click="handleProjectDetails(record)" size="small">
            项目详情
          </a-button>
        </a-space>
      </template></a-table
    >
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { useTable } from "@/views/notice/serve/table";
import {
  saveProjectLifeCycle,
  getProjectLifeCycle,
} from "@/request/view/project";
import { useRouter } from "vue-router";

export default defineComponent({
  setup() {
    const router = useRouter();

    const {
      requestConfig,
      table,
      requestPayload,
      initPayload,
      getListData,
      searchData,
      deleteRecords,
    } = useTable();

    initPayload({});

    const columns = [
      {
        title: "项目名称",
        dataIndex: "project",
        align: "center",
      },
    ];

    requestConfig.pull_fn = getProjectLifeCycle;

    const handleUpdateProject = (record) => {
      console.log(record, "+++++++++++++++");
    };

    const handleProjectDetails = (record) => {
      console.log(record);
    };

    const getData = () => {
      getListData({ unPagingRequest: true });
    };

    getData();

    return {
      table,
      columns,
      handleProjectDetails,
      handleUpdateProject,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
